export const environment = {
  production: false,
  database: 'verify-enterprise',
  localeId: 'nl',
  functionRegion: 'europe-west1',
  useEmulators: false,
  sentryDsn: '',
  sentryEnvironment: '',
  reCaptchaSiteKey: '6Lfe7zUtAAAAAK1DSzrcjmchSXO35vACfCikLBSL',
  firebaseConfig: {
    apiKey: 'AIzaSyC-R2OqM0s4_quXIqMYWKXLrtIB41o_GwY',
    authDomain: 'dev1.dev.verifyconsent.ai',
    projectId: 'fir-apps-dev-c730f',
    storageBucket: 'fir-apps-dev-c730f.appspot.com',
    messagingSenderId: '125694536324',
    appId: '1:125694536324:web:f3500ec932f221f878b0d1',
    measurementId: 'G-DHSCQYKL97',
  },
};
